import { withCompInfo } from '@wix/editor-elements-integrations'
import type { VectorImageCssVars } from '../VectorImage/VectorImage'
import { getVectorImageCSS } from '../VectorImage/VectorImageHelpers'
import { getVideoControlsDesignData } from './videoBoxUtils'
import type { MediaControlsDefinition } from './VideoBoxControls'

export const css = withCompInfo<VectorImageCssVars, MediaControlsDefinition>()(
	['compDesign', 'styleProperties', 'siteColors'],
	({ compDesign, styleProperties, siteColors }) => {
		const { resolvedSvg, design } = getVideoControlsDesignData(
			compDesign.icons,
			compDesign.iconsDefaultDesign,
			'volumeOn'
		)

		return getVectorImageCSS({
			resolvedSvg,
			design,
			styleProperties,
			siteColors,
		})
	}
)
